import React from 'react'
import LocalizedText from "@LocalizedText";
import { inject } from "@app/providers/QAU.ContextProvider";

const ProductLabel = ({ context }) => {
    if (!context.projectData) return '';
    const projectData = context.projectData;
    const productDescription = projectData.product.description
    const paperMaterial = context.paperMaterial;

    return (
        <span>
            {productDescription}
            {paperMaterial && (
                <>
                    {' '}
                    <LocalizedText id="qau-on-label-text" tagName="span"/>
                    {' '}
                    {paperMaterial.description}
                </>

            )}
        </span>
    )
}

export default inject('context')(ProductLabel);